function setFontSizeMultiplierFromStorage() {
  var storageKey = "font-size-multiplier";
  var value = localStorage.getItem(storageKey) || 1;
  document.documentElement.style.setProperty('--app-font-size-multiplier', value);
}

// Set on initial load
setFontSizeMultiplierFromStorage();

// Also set on every Turbo page load
document.addEventListener("turbo:load", setFontSizeMultiplierFromStorage);
